import type { Models } from "api/types";

export const getCustomCategoryDestinationUrl = (
  customCategory: Models<"CategoryListingsResult">,
  hasGiftCards?: boolean
) => {
  const customCategorySingularMembershipInclusionUrl =
    (customCategory.categoryInclusions.length === 1 &&
      customCategory.categoryInclusions[0].membershipId &&
      `/pdp/membership/${customCategory.categoryInclusions[0].membershipId}`) ||
    null;

  const customCategorySingularPackageInclusionUrl =
    (customCategory.categoryInclusions.length === 1 &&
      customCategory.categoryInclusions[0].packageListingId &&
      !hasGiftCards &&
      `/pdp/package/${customCategory.categoryInclusions[0].packageListingId}`) ||
    null;

  return (
    customCategorySingularMembershipInclusionUrl ??
    customCategorySingularPackageInclusionUrl ??
    `/shop/custom-category/${customCategory.category.id}`
  );
};
